import { Role } from 'constants/roles';

import { useApiContext } from 'context/apiContext';
import { number, RaRecord, required } from 'react-admin';
import { Box } from 'shared/mui/Box/Box';
import {
  AutocompleteInput,
  AutocompleteMultiselectInput,
  TextInputIntrospected,
} from 'shared/react-admin/Inputs';
import {
  ReferenceArrayInputIntrospected,
  ReferenceInputIntrospected,
} from 'shared/react-admin/ReferenceInputs';
import { User } from 'types/embedded/user';
import { getId } from 'utils/getId';

export const WorkTeamsForm = (): JSX.Element => {
  const { user } = useApiContext();

  const financeLeadValidate = (value: string) => {
    if (user.roles.includes(Role.FinanceLead)) {
      return getId(value) !== String(user.id)
        ? 'Только пользователь с ролью FINANCE LEAD, создающий "Рабочую группу", может быть назначен ее "Руководителем". Назначение других пользователей в качестве "Руководителя" в "Рабочей группе" недопустимо.'
        : undefined;
    }
    return undefined;
  };

  return (
    <>
      <TextInputIntrospected
        fullWidth
        label="Название"
        size="small"
        source="name"
        validate={required()}
        variant="outlined"
      />
      <Box display="flex" gap="24px" width="100%">
        <ReferenceArrayInputIntrospected perPage={200} reference="countries" source="countries">
          <AutocompleteMultiselectInput
            fullWidth
            label="Страны"
            name="countries"
            optionText="name"
          />
        </ReferenceArrayInputIntrospected>
        <ReferenceInputIntrospected
          filter={{ 'roleEntities.alias': [Role.FinanceLead], enabled: true }}
          perPage={50}
          reference="users"
          source="manager"
        >
          <AutocompleteInput
            filterToQuery={(searchText: string) => ({ fullName: searchText })}
            fullWidth
            label="Руководитель группы"
            name="manager"
            optionText={(record: RaRecord) => record && `${record.firstName} ${record.lastName}`}
            validate={[required(), financeLeadValidate]}
            variant="outlined"
          />
        </ReferenceInputIntrospected>
      </Box>
      <Box display="flex" gap="24px" width="100%">
        <ReferenceArrayInputIntrospected
          filter={{
            'roleEntities.alias': [Role.Finance],
            enabled: true,
          }}
          perPage={200}
          reference="users"
          source="members"
        >
          <AutocompleteMultiselectInput
            filterToQuery={(searchText: string) => ({
              fullName: searchText,
            })}
            fullWidth
            getOptionLabel={(record: User) => `${record.firstName} ${record.lastName}`}
            label="Сотрудники"
            name="members"
            source="firstName"
            validate={required()}
          />
        </ReferenceArrayInputIntrospected>
        <TextInputIntrospected
          fullWidth
          label="Reddy ID канала"
          size="small"
          source="reddyChatId"
          validate={number()}
          variant="outlined"
        />
      </Box>
    </>
  );
};
